module.exports = __webpack_public_path__ + "static/media/Leading-Edge-Aviation.e58f3099.png";